var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgJ2Search(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.54 60.55L45.8 45.37a20.07 20.07 0 10-5 3.39l13.1 15.61a3 3 0 104.63-3.81l.01-.01zM16.23 30.71a16 16 0 1132 0 16 16 0 01-32 0z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/J2_Search.7023130e.svg";
export { SvgJ2Search as ReactComponent };